import { render, staticRenderFns } from "./UspList.vue?vue&type=template&id=65102e2c&"
import script from "./UspList.vue?vue&type=script&lang=js&"
export * from "./UspList.vue?vue&type=script&lang=js&"
import style0 from "./UspList.vue?vue&type=style&index=0&id=65102e2c&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports